import PlanoService from "@/services/plano.service";

export default {
  namespaced: true,
  state: {
    grupo: null,
    grupos: [],
    groupTree: [],
    plano: null,
    planos: [],
    planosPorRede: [],
    valores: [],
    aux: [],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setPlanos: (state, planos) => state.planos = planos,
    setPlano: (state, plano) => state.plano = plano,
    setGrupos: (state, grupos) => state.grupos = grupos,
    setGrupo: (state, grupo) => state.grupo = grupo,
    setGroupTree: (state, groupTree) => state.groupTree = groupTree,
    setPlanosPorRede: (state, planosPorRede) => state.planosPorRede = planosPorRede,
    setValores: (state, valores) => state.valores = valores,
    setAux: (state, aux) => state.aux = aux
  },
  actions: {
    ['resetPlanos']({ commit }) {
      commit('setPlanos', [])
    },
    ['resetGrupos']({ commit }) {
      commit('setGrupos', [])
    },
    ['resetGrupoTree']({ commit }) {
      commit('setGroupTree', [])
    },
    ['resetPlanosPorRede']({ commit }) {
      commit('setPlanosPorRede', [])
    },
    ['resetValores']({ commit }) {
      commit('setValores', [])
    },
    ['resetAux']({ commit }) {
      commit('setAux', [])
    },
    async ['buscaGrupoPlano']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        somar_taxas,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes,
        cache,
        mei
      }
    ) {
      console.log('68: buscagrupoplano')
      try {
        commit('setLoading', true)
        const data = await PlanoService.grupo(
          uf,
          produto,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          regras_aceitacao,
          somar_taxas,
          credenciado,
          entidade,
          profissao,
          administradora,
          faixas,
          grupos_faixas,
          detalhes,
          cache,
          mei
        )
        let groupTree = []
        let planos = []
        let grupos = []
        data.map((grupo) => {
          groupTree.push({
            text: grupo.nome,
            state: { checked: true },
            data: grupo,
            children: grupo.planos.map((plano) => {
              planos.push(plano);
              return {
                text: plano.nome,
                state: { checked: true },
                data: plano,
              };
            }),
          })
        })
        commit('setGroupTree', groupTree)
        commit('setPlanos', planos)

        // Recupera os valores dos planos
        let keyValores = data
          .find((g) => g.hasOwnProperty("planos"))
          ?.planos.find((p) => p.hasOwnProperty("valores"))?.valores;
        // Recupera a chave dos valores unico ou idades
        let valores = keyValores ? Object.keys(keyValores) : [];
        // Define a chave que sera utilizada no objeto grupo para exibição da tabela
        let keyValor = valores.indexOf("unico") != -1 ? "unico" : "idade";
        commit('setValores', valores)

        if (keyValor == 'unico') {
          grupos = data.map(grupo => {
            grupo['fields'] = [
              { key: 'plano', stickyColumn: true, isRowHeader: true },
              { key: 'valor', label: 'Planos' }
            ];
            grupo['items'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc)) acc = []
              let valores = Object.keys(plano.valores)
              valores.forEach((k) => {
                let arr = { 'plano': plano.nome, 'valor': plano.valores[k] }
                acc.push(arr)
              })
              return acc
            }, {});
            return grupo
          })
        } else {
          grupos = data.map(grupo => {
            grupo['fields'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc))
                acc = [
                  { key: keyValor, stickyColumn: true, isRowHeader: true },
                ]
              acc.push({ key: plano.id, label: plano.nome })
              return acc
            }, {});
            grupo['items'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc)) acc = []
              let valores = Object.keys(plano.valores)
              valores.forEach((k) => {
                let arr = {}
                let i = acc.findIndex(p => p[keyValor] === k)
                arr[plano.id] = plano.valores[k]
                if (i == -1 ) {
                  let o = {...arr}
                  o[keyValor] = k
                  acc.push(o)
                } else {
                  acc[i] = {
                    ...acc[i],
                    ...arr
                  }
                }
              })
              return acc
            }, {});
            return grupo
          })
        }
        commit('setGrupos', grupos)
        const planosArr = new Map();
        grupos.forEach((grupo) => {
          grupo.planos.forEach((plano) => {
            const collection = planosArr.get(plano.rede_id);
            if (!collection) {
              planosArr.set(plano.rede_id, [plano]);
            } else {
              var i = collection.find((c) => c.nome == plano.nome);
              if (!i) collection.push(plano);
            }
          });
        });

        let planosPorRede = Array.from(planosArr)
          .map((p) => p[1])
          .flat();
        commit('setPlanosPorRede', planosPorRede)
      } catch (error) {
        console.log(error)
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['buscaPlano']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        somar_taxas,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes,
        mei
      }
    ) {
      try {
        commit('setLoading', true)
        const data = await PlanoService.busca(
          uf,
          produto,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          regras_aceitacao,
          somar_taxas,
          credenciado,
          entidade,
          profissao,
          administradora,
          faixas,
          grupos_faixas,
          detalhes,
          mei
        )
        let groupTree = []
        let planos = []
        let grupos = []
        data.map((grupo) => {
          groupTree.push({
            text: grupo.nome,
            state: { checked: true },
            data: grupo,
            children: grupo.planos.map((plano) => {
              planos.push(plano);
              return {
                text: plano.nome,
                state: { checked: true },
                data: plano,
              };
            }),
          })
        })
        commit('setGroupTree', groupTree)
        commit('setPlanos', planos)

        // Recupera os valores dos planos
        let keyValores = data
          .find((g) => g.hasOwnProperty("planos"))
          ?.planos.find((p) => p.hasOwnProperty("valores"))?.valores;
        // Recupera a chave dos valores unico ou idades
        let valores = keyValores ? Object.keys(keyValores) : [];
        // Define a chave que sera utilizada no objeto grupo para exibição da tabela
        let keyValor = valores.indexOf("unico") != -1 ? "unico" : "idade";
        commit('setValores', valores)

        if (keyValor == 'unico') {
          grupos = data.map(grupo => {
            grupo['fields'] = [
              { key: 'plano', stickyColumn: true, isRowHeader: true },
              { key: 'valor', label: 'Planos' }
            ];
            grupo['items'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc)) acc = []
              let valores = Object.keys(plano.valores)
              valores.forEach((k) => {
                let arr = { 'plano': plano.nome, 'valor': plano.valores[k] }
                acc.push(arr)
              })
              return acc
            }, {});
            return grupo
          })
        } else {
          grupos = data.map(grupo => {
            grupo['fields'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc))
                acc = [
                  { key: keyValor, stickyColumn: true, isRowHeader: true },
                ]
              acc.push({ key: plano.id, label: plano.nome })
              return acc
            }, {});
            grupo['items'] = grupo.planos.reduce((acc, plano) => {
              if (!Array.isArray(acc)) acc = []
              let valores = Object.keys(plano.valores)
              valores.forEach((k) => {
                let arr = {}
                let i = acc.findIndex(p => p[keyValor] === k)
                arr[plano.id] = plano.valores[k]
                if (i == -1 ) {
                  let o = {...arr}
                  o[keyValor] = k
                  acc.push(o)
                } else {
                  acc[i] = {
                    ...acc[i],
                    ...arr
                  }
                }
              })
              return acc
            }, {});
            return grupo
          })
        }
        commit('setGrupos', grupos)
        const planosArr = new Map();
        grupos.forEach((grupo) => {
          grupo.planos.forEach((plano) => {
            const collection = planosArr.get(plano.rede_id);
            if (!collection) {
              planosArr.set(plano.rede_id, [plano]);
            } else {
              var i = collection.find((c) => c.nome == plano.nome);
              if (!i) collection.push(plano);
            }
          });
        });

        let planosPorRede = Array.from(planosArr)
          .map((p) => p[1])
          .flat();
        commit('setPlanosPorRede', planosPorRede)
      } catch (error) {
        console.log(error)
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['buscaPlanoAux']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        somar_taxas,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes,
        mei
      }
    ) {
      try {
        commit('setLoading', true)
        const data = await PlanoService.grupo(
          uf,
          produto,
          tipo_plano,
          contratacao,
          cidade,
          compulsorio,
          coparticipacao,
          acomodacao,
          regras_aceitacao,
          somar_taxas,
          credenciado,
          entidade,
          profissao,
          administradora,
          faixas,
          grupos_faixas,
          detalhes,
          mei
        )
        commit('setAux', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['buscaGrupoPlanoAux']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        somar_taxas,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes,
        cache,
        mei
      }
    ) {
      return PlanoService.grupo(
        uf,
        produto,
        tipo_plano,
        contratacao,
        cidade,
        compulsorio,
        coparticipacao,
        acomodacao,
        regras_aceitacao,
        somar_taxas,
        credenciado,
        entidade,
        profissao,
        administradora,
        faixas,
        grupos_faixas,
        detalhes,
        cache,
        mei
      ).then(resp => {
        commit('setLoading', false)
        return Promise.resolve(resp)
      }, error => {
        commit('setLoading', false)
        return Promise.reject(error)
      })
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getPlano: state => state.plano,
    getPlanos: state => state.planos,
    getGrupos: state => state.grupos,
    getGrupo: state => state.grupo,
    getGroupTree: state => state.groupTree,
    getPlanosPorRede: state => state.planosPorRede,
    getValores: state => state.valores,
    getAux: state => state.aux
  }
};
